import { render, staticRenderFns } from "./AddNewBriefcaseFolderDialog.vue?vue&type=template&id=9fabd7ae&scoped=true"
import script from "./AddNewBriefcaseFolderDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddNewBriefcaseFolderDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fabd7ae",
  null
  
)

export default component.exports